import { Card } from '@iwoca/orion';
import clsx from 'clsx';
import { useReviewOffer } from 'components/ReviewOffer/ReviewOffer.context';
import { useLocale } from 'hooks/useLocale';
import { ProductTypeSelector } from './ProductTypeSelector/ProductTypeSelector';
import {
  getApplicationTableData,
  getVisibleColumns,
} from './SummaryCard.helpers';
import styles from './SummaryCard.module.css';
import { SummaryCardColumn } from './SummaryCardColumn/SummaryCardColumn';
import { SummaryCardLabels } from './SummaryCardLabels/SummaryCardLabels';

export const SummaryCard = () => {
  const {
    selectedApplication: application,
    hasInterestOnlyOffer,
    isRCFView,
    hasBothProductTypes,
    activeProductType,
    showProductSelector,
  } = useReviewOffer();
  const { isDE } = useLocale();

  const { columns, fields } = getApplicationTableData(application, isRCFView);

  const visibleColumns = getVisibleColumns(
    columns,
    hasBothProductTypes,
    activeProductType,
    isDE,
  );

  return (
    <>
      {showProductSelector && (
        <ProductTypeSelector selectedType={activeProductType} />
      )}
      {(!hasBothProductTypes || activeProductType !== null) && (
        <Card
          className={clsx(styles.summaryCard, styles[application.status], {
            [styles.hasInterestOnlyOffer]: hasInterestOnlyOffer,
            [styles.isRCFView]: isRCFView,
          })}
          data-testid="summary-card"
        >
          <SummaryCardLabels fields={fields} />
          <div className={styles.summaryCardColumns}>
            {visibleColumns.map((offer, i) => (
              <SummaryCardColumn
                key={`${offer.product_type}-${i}`}
                fields={fields}
                hasAction={
                  application.status === 'offered' ||
                  application.status === 'conditional_offer'
                }
                offer={offer}
                applicationId={application.application_uid}
              />
            ))}
          </div>
        </Card>
      )}
    </>
  );
};
